// Gatsby requirements
import React from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './Faq.module.scss'


const Faq = ({ data }) => {

    return (
        <section 
            className={`
                ${CSS.section}
                ${'section' + data._uid}
                ${data.margin === '4rem top & 4rem bottom' ? CSS.margin4em4em : ''}
                ${data.margin === '0rem top & 6rem bottom' ? CSS.margin0em6em : ''}
            `}
            id={data.anchorId}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid)
                }} />
            }

            <h2>{data.title}</h2>
            
            {data?.faq && data?.faq?.map((loop, i) => (
                <details key={i}>
                    <summary>{loop.title}</summary>
                    <RichText content={loop.answer} />
                </details>
            ))}
        </section>
    )
}

export default Faq
